/** An error type for application-level failures that carries structured data. */
export class ApplicationError extends Error {
    data;
    /** Creates a new ApplicationError with the given message and structured data. */
    constructor(message, data) {
        super(message, data);
        this.data = data;
        this.name = 'ApplicationError';
    }
}
//# sourceMappingURL=ApplicationError.js.map